export const iconFontAwesomeConnectivityRss = (
	<i className="fa-solid fa-rss"></i>
);
